import PhysicalPackageCreate from './PhysicalPackageCreate'
import PhysicalPackageEdit from './PhysicalPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const physicalPackageIndex = {
  list: buildPackageList('physicals'),
  edit: PhysicalPackageEdit,
  create: PhysicalPackageCreate,
}

export default physicalPackageIndex
